module.exports = __webpack_public_path__ + "img/yml_gallery18.14c3a98a.jpg";